import styled from "styled-components";
import React from "react";
import { UserEmail } from "../../assets/User/UserEmail";

const StyleCss = styled.div`
  
`;

function ChangeEmail(props) {
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
          <div className="icon"><UserEmail/></div>
          <div className="text">تغییر ایمیل</div>
          </div>
      </div>
      <div className="content">
      </div>
    </StyleCss>
);
}
export default ChangeEmail;